module.exports = __webpack_public_path__ + "static/media/tick.98077282.png";